module.exports = new __parcel__URL__("machines_tab_inactive.2ec23b71.png").toString();